import { gql } from '@apollo/client';

export const FRONTEND_CONFIG_FRAGMENT = gql`
  fragment frontendConfigValues on FrontendConfig {
    frontendReleaseDate
    frontendVersion
  }
`;
